/*set components*/
import Home  from './Home';
/*set icons*/
import HomeIcon from '@mui/icons-material/Home';


export const routes_modules = [
  {
    name: "Home",
    path: "/",
    component: Home,
    menu: true,
    private: false,
    icon: <HomeIcon />,
  },
];
